"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GridConstants {
}
GridConstants.EXPANDING_HEIGHT_TRANSITION_TIMING = 250;
GridConstants.GRID_COLUMN_SORTABLE = "sortable";
GridConstants.GRID_COLUMN_SORTED = "sorted";
GridConstants.EXPANDABLE = "expandable";
GridConstants.GRID_ROW_EXPAND_EXPANDED = "expand-expanded";
GridConstants.GRID_ROW_EXPAND_EXPANDED_READY = "expand-expanded-ready";
GridConstants.GRID_ROW_EXPAND_VIEW = "grid-expanded-view";
GridConstants.GRID_ROW_EXPAND_EXPANDED_ANIMATED = "expand-expanded-animated";
GridConstants.GRID_ROW_EXPANDED = "expanded";
GridConstants.TD_EXPANDER = "td-expander";
GridConstants.GRID_ROW_SELECTED = "grid-row-selected";
GridConstants.GRID_CELL_FIRST = "first";
GridConstants.GRID_ROW_FIRST = "first";
GridConstants.GRID_CELL_LAST = "last";
GridConstants.GRID_ROW_LAST = "last";
GridConstants.GRID_HEADER_ROW = "group-header-row";
GridConstants.GRID_DROP_TARGET = "grid-drop-target";
GridConstants.GRID = "grid";
GridConstants.GRID_TABLE = "grid-table";
GridConstants.GRID_LOADING = "grid-loading";
GridConstants.HIDE_CAPTION = "hide-caption";
GridConstants.EMPTY_GRID = "empty-grid";
GridConstants.EXPANDED_GROUP = "expanded-group";
GridConstants.EXPANDED_GROUP_FIRST = "expanded-group-first";
GridConstants.EXPANDED_GROUP_LAST = "expanded-group-last";
GridConstants.GRID_ATTRIBUTE_DATAROW = "datarow";
GridConstants.DELETE_ROW_COLUMN = "delete-row-column";
exports.default = GridConstants;
//# sourceMappingURL=GridConstants.js.map